module.exports = __webpack_public_path__ + "img/footer_logo1.9dac1bbf.jpg";